import { css } from '@emotion/react';
import { useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

function LoadingSpinner() {
    const [loading, setLoading] = useState(true);
    const [color, setColor] = useState('#f3f4f6'); // #AEC766

    return (
        <div className="flex items-center justify-center">
            {/* 
            // @ts-ignore */}
            <BeatLoader color={color} loading={loading} css={override} size={13} margin={2} />
        </div>
    );
}

export { LoadingSpinner };
